import type { FaireProductEntity } from "../../entity_types/product";

export const p_um4pnzf3ku: FaireProductEntity = {
  token: "p_um4pnzf3ku",
  type: "product",
  name: "Mineral Wash Cotton Crop Tank & Wide Leg Pant Set",
  brandToken: "b_elccldtdr7",
  brandName: "Urban Daizy",
  imageUrl:
    "https://cdn.faire.com/fastly/8f29dc6022301041ba6b06abda22da07db124cc4f874b951790bf23c5cc568c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f00d782c0bafeed0c0ba6d5c3c46ad38f6c0f91776e847a317b9b5a494b2aa24.jpeg",
    "https://cdn.faire.com/fastly/e47d4a709651bd056d1cc3315a3ae668f691c306acbc4f6968852cf481c1d5ad.jpeg",
    "https://cdn.faire.com/fastly/516ccede5d45571c0f85652d80e91c3bdf19a43ac8ea5b16755a24af1e44e9f5.jpeg",
    "https://cdn.faire.com/fastly/c7b88783d4d6b50b27dd0fa74cfa72c5d40eb27717ed4fee0a7c493dfe678bbe.jpeg",
    "https://cdn.faire.com/fastly/459a42f20d376584954ee389938f8044b2bf09bb38664ca18064543be9a00f5c.jpeg",
    "https://cdn.faire.com/fastly/a99dd0a80c83eb401b755f4e6ee59f75a48f2e2d53688e048224fb910b1020a9.jpeg",
    "https://cdn.faire.com/fastly/6c4743c865fd43cb01d0f13489c85a88515794b6e08e4af98526735a51b745b6.jpeg",
    "https://cdn.faire.com/fastly/fbbddd323cc1e96e91ada893dec17e2067de30d43e68bb1a93e7958ff26d5506.jpeg",
    "https://cdn.faire.com/fastly/cd6ed09199fa8e68f9170835b53f88f928d417f97972045004073af46b306667.jpeg",
    "https://cdn.faire.com/fastly/1db11d827d330c6345f3c93eea4facd04c4196ae2b4577c6f581ea2223fae308.jpeg",
    "https://cdn.faire.com/fastly/c225b096e9104be7fbe8d82ce890923b1bb7e7c941fab1502fad108fa6b5f827.jpeg",
    "https://cdn.faire.com/fastly/53fc89b859913cff6ef4fbfc9f21a37aeacb343a36992f69af7478ac280f9bd4.jpeg",
    "https://cdn.faire.com/fastly/bce7a27e4a245245e0122b5cf7906eab5cd5077c96c1ebdc5a3fb073d0c9ff78.jpeg",
  ],
  priceDollars: 33.99,
  description:
    'Achieve the perfect off-duty look with this mineral wash matching set. Combining the cool, vintage aesthetic of denim with the soft stretch of cotton, this two-piece set features a structured crop tank and flowy wide-leg pants for effortless travel or weekend style.\n \n Product Details:\n \n Top Design: A sleeveless crew-neck crop top featuring vertical exposed seam detailing that contours the bodice.\n \n Bottoms: Matching wide-leg pants equipped with a comfortable elastic waistband and adjustable drawstring tie.\n \n Finish: Treated with a blue mineral/acid wash that gives the fabric a trendy, lived-in "faux denim" appearance.\n \n Material: 95% Cotton, 5% Spandex (Breathable natural fibers with excellent stretch and recovery).\n \n Sizing Pack: Sold in a 2-2-2 pack (2 Small, 2 Medium, 2 Large).\n \n Origin: Made in China.',
  tags: [],
  msrpDollars: 67.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:41.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
